import React, { useMemo } from 'react';

import useMergeProps from '../../hooks/useMergeProps';
import useTypedSelector from '../../hooks/useTypedSelector';

import BetCurrentTotalTag from './BetCurrentTotalTag';
import makeBetCurrentTotalTagPropsSelector from './BetCurrentTotalTag.selector';

type BetCurrentTotalTagContainerProps = {
  className?: string;
  betId: number;
  isFromPlayerRow?: boolean;
};

const BetCurrentTotalTagContainer = ({
  betId,
  isFromPlayerRow = false,
  ...ownProps
}: BetCurrentTotalTagContainerProps) => {
  const selectorProps = useMemo(() => ({ betId, isFromPlayerRow }), [betId, isFromPlayerRow]);
  const selector = useMemo(() => makeBetCurrentTotalTagPropsSelector(), []);
  const selectedProps = useTypedSelector((state) => selector(state, selectorProps));

  const { currentTotal, ...enhancedProps } = useMergeProps({ ownProps, selectedProps });

  if (currentTotal !== undefined) {
    return <BetCurrentTotalTag {...enhancedProps} currentTotal={currentTotal} />;
  }

  return null;
};

export default BetCurrentTotalTagContainer;
